import { render, staticRenderFns } from "./step_8.vue?vue&type=template&id=370fd7ed&"
import script from "./step_8.vue?vue&type=script&lang=js&"
export * from "./step_8.vue?vue&type=script&lang=js&"
import style0 from "./step_8.vue?vue&type=style&index=0&id=370fd7ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports